/* Coupon del carrello (pagina /cart + drawer) — replica di summary.tsx
   (CartDiscounts + UpdateDiscountForm) e dell'action DiscountCodesUpdate
   (($locale).cart.tsx:57-70) dell'headless:
   - Applica  = cartDiscountCodesUpdate([...codici già applicati, nuovo]) — ADDITIVO
   - Rimuovi  = cartDiscountCodesUpdate([]) — azzera tutti i codici, come il live
   Il carrello Online Store è lo stesso cart della Storefront API: il gid si
   ricava dal cookie `cart` (token+key URL-encoded, la key è obbligatoria —
   stessa scoperta del 06/08 in iv-cart-extras).
   Config sul tag <script>: data-token (Storefront PUBBLICO), data-domain.
   Senza token/cart: fallback nativo /discount/<code>?redirect=/cart (solo apply).
   Come il live, un codice non applicabile non mostra errori: semplicemente
   non compare tra gli applicati (summary.tsx filtra per `applicable`). */
(function () {
  var script = document.currentScript;
  var TOKEN = script && script.dataset.token;
  var DOMAIN = script && script.dataset.domain;

  function cartGid() {
    var m = document.cookie.match(/(?:^|; )cart=([^;]+)/);
    return m ? 'gid://shopify/Cart/' + decodeURIComponent(m[1]) : null;
  }

  function appliedCodes(scope) {
    return Array.prototype.map.call(
      scope.querySelectorAll('.iv-coupon__remove'),
      function (b) { return b.dataset.code; }
    );
  }

  function updateCodes(codes) {
    var gid = cartGid();
    if (!TOKEN || !gid) return Promise.reject(new Error('no token/cart'));
    return fetch('https://' + DOMAIN + '/api/2024-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': TOKEN,
      },
      body: JSON.stringify({
        query:
          'mutation($cartId: ID!, $codes: [String!]) {' +
          ' cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $codes) {' +
          ' cart { discountCodes { code applicable } } userErrors { message } } }',
        variables: {cartId: gid, codes: codes},
      }),
    }).then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    }).then(function (d) {
      if (!d.data || !d.data.cartDiscountCodesUpdate) throw new Error('bad response');
      return d;
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var apply = e.target.closest('.iv-coupon__apply');
    var remove = e.target.closest('.iv-coupon__remove');
    if (!apply && !remove) return;
    var btn = apply || remove;
    if (btn.disabled) return;
    var box = btn.closest('.iv-coupon');
    var codes;
    if (apply) {
      var input = box && box.querySelector('.iv-coupon__input');
      var code = input && input.value.trim();
      if (!code) return;
      codes = appliedCodes(box).concat(code);
    } else {
      codes = []; // il live rimuove tutti i codici in un colpo solo
    }
    btn.disabled = true;
    updateCodes(codes)
      .then(function () {
        // il totale scontato e la lista codici arrivano dal re-render Liquid
        window.location.reload();
      })
      .catch(function () {
        if (apply) {
          // fallback nativo senza token: applica il solo codice digitato
          window.location.href =
            '/discount/' + encodeURIComponent(codes[codes.length - 1]) + '?redirect=/cart';
        } else {
          btn.disabled = false;
        }
      });
  });
})();
